import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useCallback,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import moment from "moment";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import {
  fetchAllPostPromisedData,
  isObjEmpty,
  generateRandomId,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import {
  failureToast,
} from "../../../../common/utils/methods/toasterFunctions/function";
import { AGridColDef } from "../../../../common/data-grid/ADataGridColDef";
import { saveOrDeleteMsg } from "../sapProfitCostCentreMapping/constant";
import { editCellContainerStyle } from "../onBoardingMaterialIdSetup/constant";
import ALoader from "views/pages/manage/common/a-loader";
import { regex } from "views/pages/manage/common/constant/regex/index";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import {
  gridStyles,
  gridComponents,
} from "../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { Tooltip } from "@material-ui/core";
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";
import { ReactComponent as DeleteIcon } from "assets/img/svg/Delete.svg";
import {
  ActionsCellComponent,
} from "../../../../masters/studentFinancials/paymentGatewaysConfiguration/common";
import { newRow, areAllMandatoryFieldsFilled } from "./constants";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import ServiceOrderDialog from "./ServiceOrderDialog";
import styles from "./styles.module.scss";
import { hardcodeDropdown, findLabelByValue } from "./constants";
import SelectMaterialElasticSearch from "../onBoardingMaterialIdSetup/SelectMaterialElasticSearch";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { endpoint } from "../../../../common/constant";
import { FaTrashRestore } from "react-icons/fa";
import { MdDelete, MdDeleteForever } from "react-icons/md";
import ReleaseStratDialog from "./ReleaseStratDialog";
import { ReactComponent as EyeIcon } from "assets/img/svg/eyeIcon.svg";

const ListComponent = (
  {
    rows = [],
    loading,
    setLoading,
    currentPage,
    totalRecords,
    dropdownData,
    pageChangeHandler,
    createUpdateHandler,
    purchaseReqType,
    updatePurchaseOrder,
    listing = false,
    deleteItemHandler,
    headerData
  },
  ref
) => {
  const [rowModesModel, setRowModesModel] = useState({});
  const [rowForm, setRowForm] = useState({});
  const [rowData, setRowData] = useState(rows);
  const [isOpen, setIsOpen] = useState(null);
  const [isOpenRel, setIsOpenRel] = useState(null);
  const [serviceParam, setServiceParam] = useState({});
  const [releaseStratParam, setReleaseStratParam] = useState({});
  const [sapCostCenter, setSapCostCenter] = useState({});
  const isTableInEditMode = Object.keys(rowForm)?.length !== 0;
  const [lastFetchedPlant, setLastFetchedPlant] = useState(null);

  const requiredFields = [
    "Item_no",
    "Quantity",
    "Plant",
    "Purchase_group",
    "Requisitioner",
    "Vendor",
    // "Asset_no",
    ...(rowForm?.Account_asignment?.value === "A" ? ["Asset_no"] : []),
    ...(purchaseReqType === "opexPr" && rowForm?.Account_asignment?.value == "K" ? ["Cost_Center"] : []),
    ...(purchaseReqType !== 'servicePr' ? ["Material_no"] : []),
    // ...(purchaseReqType !== "servicePr" && purchaseReqType !== "normalPr" ? ["Account_asignment"] : [])
  ];

  const saveHandler = (serviceRowData) => {
    // const serviceDataList=[...rowForm?.serviceData,serviceRowData]
    setRowForm((prev) => ({ ...prev, Service_Item: serviceRowData }));
  };

  useEffect(() => {
    setRowData(rows);
  }, [rows]);

  const rowFormHandler = (value, key) => {
    setRowForm((prev) => ({ ...prev, [key]: value }));
  };

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
    setRowForm(form);
  };

  const stopEditing = () => {
    const currForm = { ...rowForm };
    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleCancelClick = async (params) => {
    if (params?.row?.isNew) {
      setRowData(rows);
      setRowForm({});
    } else {
      stopEditing();
    }
  };

  const handleSaveClick = async (params) => {
    let emailRegex = regex?.email;
    if (!emailRegex.test(headerData?.Email_id)) {
      failureToast("Please enter valid email");
    } else if (rowForm?.Purchase_group?.value === 'MRK' && (!headerData?.Campaign_Name || !headerData?.Campaign_Name?.value)) {
      failureToast("Please select campaign name");
    } else {
      createUpdateHandler(rowForm);
    }
  };

  const addNewRow = async () => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      let randomId = generateRandomId();
      let emptyRow = {
        ...newRow,
        isNew: true,
        Item_no: rowData.length + 1,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
    }
  };

  useImperativeHandle(ref, () => ({
    addNewRow: addNewRow,
    startEditing: startEditing,
    stopEditing: stopEditing,
    isTableInEditMode: isTableInEditMode
  }));

  const fetchCostCenter = useCallback(
    async (plant) => {
      if (!plant || plant === lastFetchedPlant) return;
      try {
        const res = await fetchAllPostPromisedData(
          `${endpoint.sapProfitCostCentreMapping.searchProfitCostCenter
          }?offset=${0}`,
          {
            sapBusinessArea: plant?.value,
            costCenterStatus: "ACTIVE",
          },
          "post"
        );
        if (res && res?.code === 200)
          setSapCostCenter(
            res?.data?.profitCostCenterList.map((item) => ({
              value: item?.costCenter,
              label: `${item?.costCenter}-${item?.profitCenterDescription}`,
            }))
          );
        setLastFetchedPlant(plant);
      } catch (err) {
        console.log("Error fetching cost centers", err);
      }
    },
    [lastFetchedPlant]
  );

  useEffect(() => {
    if (rowForm?.Plant && rowForm?.Plant !== lastFetchedPlant) {
      fetchCostCenter(rowForm?.Plant);
    }
  }, [rowForm?.Plant, lastFetchedPlant]);

  const baseColumns = [
    new AGridColDef("Item_no", "Item No*", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.Item_no}
            handler={(val) => {
              rowFormHandler(val, "Item_no");
            }}
            placeholder={""}
            maxLength={5}
          />
        </div>
      )),
    // new AGridColDef("Account_asignment", (purchaseReqType === 'servicePr' || purchaseReqType === 'normalPr') ? "Account Assignment" : "Account Assignment*", false)
    new AGridColDef("Account_asignment", "Account Assignment", false)
      .setMinWidth(190)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.Account_asignment}
            handleChange={(value) => {
              rowFormHandler(value, "Account_asignment");
              rowFormHandler("", "Item_cat");
            }}
            items={hardcodeDropdown?.Account_asignment}
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isClearable={true}
          />
        </div>
      )),
    new AGridColDef("Item_cat", "Item Category", false)
      .setMinWidth(120)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.Item_cat}
            handleChange={(value) => {
              rowFormHandler(value, "Item_cat");
              if (value?.value === "D") {
                rowFormHandler("SERVICES", "Material_group");
              }
            }}
            items={
              // rowForm?.Account_asignment?.label === "Standard"
              //   ? hardcodeDropdown?.Item_cat?.filter(item => item?.label === "Standard")
              //   : rowForm?.Account_asignment?.value === "A"
              //     ? hardcodeDropdown?.Item_cat?.filter(item => item?.value === "D")
              //     : rowForm?.Account_asignment?.value === "K"
              //       ? []  // No items if Account_asignment is "K"
              // :
              hardcodeDropdown?.Item_cat // Show all other cases
            }
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isClearable={true}
          />
        </div>
      )),
    new AGridColDef("Plant", "Plant*", false)
      .setMinWidth(120)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => !listing ? params?.value?.label : params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.Plant}
            handleChange={(value) => {
              rowFormHandler(value, "Plant");
              rowFormHandler("", "Cost_Center");
              // rowFormHandler("SLOC", "Storage_Location");
              // fetchCostCenter(value);
            }}
            items={[
              ...(dropdownData?.allActiveBu || []),
              ...hardcodeDropdown.additionalPlant
            ]}
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isClearable={true}
          />
        </div>
      )),
    new AGridColDef("Material_no", (purchaseReqType === "servicePr") ? "Material" : "Material*", false)
      .setMinWidth(190)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <SelectMaterialElasticSearch
            currentValue={rowForm?.Material_no}
            handleChange={(value) => {
              rowFormHandler(value, "Material_no");
              rowFormHandler(value?.materialDescription, "Material_text")
              rowFormHandler(value?.uom, "Unit")
              rowFormHandler(value?.materialGroup, "Material_group")
            }}
            isMulti={false}
            // plantId={rowForm?.Plant?.value}
            // isDisabled={!rowForm?.Plant}
            dropdownMappingParams={[
              "materialIdAndDescription",
              "materialId",
              "materialDescription",
            ]}
          />
        </div>
      )),
    new AGridColDef("Material_text", "Material Short Text", false)
      .setMinWidth(190)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.Material_text}
            handler={(val) => rowFormHandler(val, "Material_text")}
            placeholder={""}
            disabled={purchaseReqType != 'servicePr'}
          />
        </div>
      )),
    new AGridColDef("Material_group", "Material Group", false)
      .setMinWidth(140)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.Material_group}
            handler={(val) => rowFormHandler(val, "Material_group")}
            placeholder={""}
            disabled={purchaseReqType != 'servicePr'}
          />
        </div>
      )),
    new AGridColDef("Unit", "Unit", false)
      .setMinWidth(60)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.Unit}
            handler={(val) => rowFormHandler(val, "Unit")}
            placeholder={""}
            disabled={purchaseReqType === 'servicePr'}
            regex={regex.numeric}
          />
        </div>
      )),
    new AGridColDef("Quantity", "Quantity*", false)
      .setMinWidth(90)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.Quantity}
            handler={(val) => rowFormHandler(val, "Quantity")}
            placeholder={""}
            regex={regex.numeric}
          />
        </div>
      )),
    new AGridColDef("Delivery_date", "Delivery Date", false)
      .setMinWidth(180)
      .editable(true)
      .setFlex(1)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${moment(params?.value).format("DD MMM YYYY")}`}>
              <div className={`ellipsis-text-container`}>{`${moment(
                params?.value
              ).format("DD MMM YYYY")}`}</div>
            </Tooltip>
          </>
        ) : (
          <div>-</div>
        )
      )
      .renderEditCellComponent((params) => (
        <CustomDatePickerV2
          placeHolder="From"
          minDate={!listing ? moment(new Date()) : moment(params?.row?.Delivery_date)}
          // maxDate={moment(new Date())}
          value={rowForm?.Delivery_date}
          width={"18px"}
          handler={(index, date, keyName) => {
            rowFormHandler(moment(date).startOf("day"), "Delivery_date");
          }}
        />
      )),
    // new AGridColDef("Storage_Location", "Storage Location", false)
    //   .setMinWidth(140)
    //   .setFlex(1)
    //   .editable(true)
    //   .setValueGetter((params) => params?.value)
    //   .renderEditCellComponent((params) => (
    //     <div style={editCellContainerStyle}>
    //       <AInput
    //         value={rowForm?.Storage_Location}
    //         placeholder={""}
    //         disabled
    //       />
    //     </div>
    //   )),
    new AGridColDef("Purchase_group", "Purchase Group*", false)
      .setMinWidth(170)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.Purchase_group}
            handleChange={(value) => {
              rowFormHandler(value, "Purchase_group");
            }}
            items={hardcodeDropdown?.Purchase_group}
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isClearable={true}
          />
        </div>
      )),
    new AGridColDef("Requisitioner", "Requiestioner*", false)
      .setMinWidth(130)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.Requisitioner}
            handler={(val) => rowFormHandler(val, "Requisitioner")}
            placeholder={""}
            maxLength={12}
            regex={regex?.alphabetsWithSpace}
          />
        </div>
      )),
    new AGridColDef("Vendor", "Desired Vendor*", false)
      .setMinWidth(180)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <SelectMaterialElasticSearch
            currentValue={rowForm?.Vendor}
            handleChange={(value) => {
              rowFormHandler(value, "Vendor");
            }}
            isMulti={false}
            dropdownMappingParams={[
              "vendorCodeAndName",
              "vendorCode",
              "name"
            ]}
            category="VendorMaster"
            isPlantIdRequired={false}
          />
        </div>
      )),
    new AGridColDef("Asset_no", rowForm?.Account_asignment?.value === "A" ? "Asset Number*" : "Asset Number", false)
      .setMinWidth(140)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <SelectMaterialElasticSearch
            currentValue={rowForm?.Asset_no}
            handleChange={(value) => {
              rowFormHandler(value, "Asset_no");
              // rowFormHandler(value?.subAssetNo, "SubAsset_no")
            }}
            isMulti={false}
            // plantId={rowForm?.Plant?.value}
            isDisabled={rowForm?.Account_asignment?.value !== "A"}
            dropdownMappingParams={[
              "assetNoAndAssetTxt",
              "assetNo",
              "assetTxt",
              // "subAssetNo"
            ]}
            category="AssetMaster"
            isPlantIdRequired={false}
          />
        </div>
      )),
    // new AGridColDef("SubAsset_no", "Sub Number", false)
    //   .setMinWidth(120)
    //   .setFlex(1)
    //   .editable(true)
    //   .setValueGetter((params) => params?.value)
    //   .renderEditCellComponent((params) => (
    //     <div style={editCellContainerStyle}>
    //       <AInput
    //         value={rowForm?.SubAsset_no}
    //         placeholder={""}
    //         maxLength={4}
    //         regex={regex.alphabetsWithSpace}
    //         disabled
    //       />
    //     </div>
    //   )),
  ];
  /*
    const baseColumns2 = [
      new AGridColDef("Telephone_no", "Telephone*", false)
        .setMinWidth(140)
        .setFlex(1)
        .editable(true)
        .setValueGetter((params) => params?.value)
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              value={rowForm?.Telephone_no}
              handler={(val) => rowFormHandler(val, "Telephone_no")}
              placeholder={""}
              maxLength={10}
              regex={regex?.numeric}
            />
          </div>
        )),
      new AGridColDef("Department", "Department Name*", false)
        .setMinWidth(160)
        .setFlex(1)
        .editable(true)
        .setValueGetter((params) => params?.value?.label)
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.Department}
              handleChange={(value) => {
                rowFormHandler(value, "Department");
              }}
              items={hardcodeDropdown?.Department}
              isMulti={false}
              placeholder={"Select"}
              autoFocus={params?.hasFocus}
              isClearable={true}
            />
          </div>
        )),
      new AGridColDef("Email_id", "Email*", false)
        .setMinWidth(170)
        .setFlex(1)
        .editable(true)
        .setValueGetter((params) => params?.value)
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              value={rowForm?.Email_id}
              handler={(val) => rowFormHandler(val, "Email_id")}
              placeholder={""}
              maxLength={50}
            />
          </div>
        )),
    ];  
    */

  const nonCapexColumns = [
    ...(purchaseReqType === "opexPr" || purchaseReqType === "normalPr"
      ? [
        new AGridColDef("Cost_Center", purchaseReqType !== 'normalPr' ? "Cost Center*" : "Cost Center", false)
          .setMinWidth(140)
          .setFlex(1)
          .editable(true)
          .setValueGetter((params) => params?.value?.label)
          .renderEditCellComponent((params) => (
            <div style={editCellContainerStyle}>
              <AAutoComplete
                currentValue={rowForm?.Cost_Center}
                handleChange={(value) => {
                  rowFormHandler(value, "Cost_Center");
                }}
                items={sapCostCenter}
                isMulti={false}
                //   style={selectStyles}
                placeholder={"Select"}
                autoFocus={params?.hasFocus}
                isClearable={true}
              // isDisabled={!rowForm?.isNew}
              />
            </div>
          )),
      ]
      : []),
    // ...baseColumns2,
    ...(purchaseReqType === "servicePr"
      ? [
        new AGridColDef("Service_Item", "Add Service", false)
          .setMinWidth(150)
          .setFlex(1)
          .editable(true)
          .renderCellComponent((params) => (
            <AButton
              variant="link"
              className="no-ml-btn"
              onClick={() => {
                setServiceParam(params);
                setIsOpen({ mode: "view" });
              }}
              size="xs"
            >
              {params?.row?.Service_Item?.length > 0 ? `${params?.row?.Service_Item?.length} Services Added` : ''}
            </AButton>
          ))
          .renderEditCellComponent((params) => (
            <AButton
              variant="link"
              onClick={() => {
                setServiceParam(params);
                setIsOpen({ mode: "edit" });
              }}
              disabled={!rowForm?.Plant}
              size="xs"
            > {rowForm?.Service_Item ? 'Edit' : 'Add'}
            </AButton>
          )),
      ]
      : []),
  ];


  const handleDelete = (id) => {
    /*
    *
    same function in case of listing it delete by calling api
    in case of create pr it creates in memory
    */
    if (listing) {
      // const rowIndex = rowData?.findIndex((row) => row.id === rowForm.id);
      // const rowToDelete = rowData?.find(row => row?.id === id);
      // if (Object.keys(rowToDelete)?.length > 0) {
      deleteItemHandler(id);
      // }
    } else {
      let tempArray = [];
      let newItemNo = 1;

      for (let i = 0; i < rowData.length; i++) {
        if (rowData[i]?.id !== id) {
          let updatedRow = { ...rowData[i], Item_no: newItemNo };
          if (updatedRow.Service_Item?.length) {
            updatedRow.Service_Item = updatedRow.Service_Item.map((service, index) => ({
              ...service,
              // Item_no: (index + 1),
              // Line_No: newItemNo,
              Item_no: newItemNo,
              SrvLine: (index + 1)
            }));
          }

          tempArray.push(updatedRow);
          newItemNo++;
        }
      }
      setRowData(tempArray);
      updatePurchaseOrder(tempArray);
    }
  };

  const handleUnDelete = (id) => {
    if (listing) {
      deleteItemHandler(id, true);
    }
  };


  const actionColumns = [
    ...(listing ? [
      new AGridColDef("Release_details", "Release Strategy", false)
        .setMinWidth(150)
        .setFlex(1)
        .editable(false)
        .renderCellComponent((params) => (
          <AButton
            variant="link"
            className="no-ml-btn"
            onClick={() => {
              setReleaseStratParam(params);
              setIsOpenRel({ mode: "view" });
            }}
            size="xs"
          >
            <span>
              <EyeIcon />
            </span>
          </AButton>
        ))
    ] : []
    ),
    new AGridColDef("actions", "Action", false)
      .setMinWidth(190)
      .setFlex(1)
      .editable(true)
      .columnAlign("center")
      .renderCellComponent((params) => (
        <div className="d-flex">
          <ActionsCellComponent
            mode={params.api.getRowMode(params?.id)}
            handleEditClick={handleEditClick}
            params={params}
            isSaveDisabled={listing && params?.row?.Delete_ind === 'X'}
          />
          <div className="mx-2 cursor">
            {params?.row?.Delete_ind !== 'X' ?
              <Tooltip title="Delete">
                <span>
                  <MdDelete style={{ color: "grey", fontSize: "30px" }} onClick={() => { handleDelete(params?.row?.id); }} />
                </span>
              </Tooltip>
              :
              <Tooltip title="Undo Delete">
                <span>
                  <MdDeleteForever style={{ color: "#E7685A", fontSize: "30px" }} onClick={() => { handleUnDelete(params?.row?.id) }} />
                </span>
              </Tooltip>
            }
          </div>
        </div>
      ))
      .renderEditCellComponent((params) => (
        <ActionsCellComponent
          mode={"edit"}
          isSaveDisabled={!areAllMandatoryFieldsFilled(rowForm, requiredFields)}
          handleSaveClick={handleSaveClick}
          handleCancelClick={handleCancelClick}
          params={params}
          cancelIcon={
            <CloseIcon
              className="mx-2 cursor"
              onClick={() => handleCancelClick(params)}
            />
          }
        />
      )),
  ];

  const columns = [
    ...baseColumns,
    ...(purchaseReqType === "capexPr" ? [] : nonCapexColumns),
    ...actionColumns,
  ];

  return (
    <>
      {loading && <ALoader position="fixed" />}
      {purchaseReqType && (
        <div
          className=""
          style={{ border: "1px solid #EEE", borderRadius: "8px" }}
        >
          <ADataGrid
            removeWrapperContainer
            autoHeight
            sx={{
              ...gridStyles,
            }}
            rowModesModel={rowModesModel}
            rows={rowData || []}
            columns={columns}
            rowId={(row) => (row?.id)}
            rowHeight={50}
            loading={false}
            rowCount={rowData.length}
            currentPage={currentPage}
            nextButtonHandler={pageChangeHandler}
            hidePagination
            components={{
              ...gridComponents,
              NoRowsOverlay: () => (
                <NoRowOverlay message={loading ? "Loading..." : null} />
              ),
            }}
          />
        </div>
      )}
      {isOpen && (
        <ServiceOrderDialog
          rowForm={rowForm}
          setRowForm={setRowForm}
          isView={true}
          params={serviceParam}
          dropdownData={{ ...dropdownData, sapCostCenter }}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          saveHandler={saveHandler}
          rows={
            serviceParam.api.getRowMode(serviceParam?.id) == "view"
              ? serviceParam?.row?.Service_Item
              : rowForm?.Service_Item
          }
          listing={listing}
          deleteItemHandler={deleteItemHandler}
        />
      )}

      {isOpenRel && (
        <ReleaseStratDialog
          isOpenRel={isOpenRel}
          setIsOpenRel={setIsOpenRel}
          rows={releaseStratParam.api.getRowMode(releaseStratParam?.id) == "view"
            ? releaseStratParam?.row
            : rowForm}
        />
      )}
    </>
  );
};

export default forwardRef(ListComponent);
